import { FormEvent, useState } from "react";
import { Mail } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { studioEmailKey } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

export function Contact() {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", topic: "", message: "" });

  function updateField(field: keyof typeof form, value: string) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const studioEmail = t(studioEmailKey);
    const subject = encodeURIComponent(`Verdantfall inquiry: ${form.topic || "General"}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nTopic: ${form.topic}\n\n${form.message}`
    );
    window.location.href = `mailto:${studioEmail}?subject=${subject}&body=${body}`;
  }

  return (
    <>
      <PageHero title={t("contact.hero.title")} body={t("contact.hero.body")} image="/concepts/aurel-world-map-concept.png" />

      <section className="content-band contact-band">
        <div className="section-inner contact-grid">
          <form className="contact-form" onSubmit={handleSubmit} data-reveal>
            <label>
              <span>{t("contact.form.name")}</span>
              <input value={form.name} onChange={(event) => updateField("name", event.target.value)} required />
            </label>
            <label>
              <span>{t("contact.form.email")}</span>
              <input
                type="email"
                value={form.email}
                onChange={(event) => updateField("email", event.target.value)}
                required
              />
            </label>
            <label>
              <span>{t("contact.form.topic")}</span>
              <input value={form.topic} onChange={(event) => updateField("topic", event.target.value)} />
            </label>
            <label>
              <span>{t("contact.form.message")}</span>
              <textarea value={form.message} onChange={(event) => updateField("message", event.target.value)} required />
            </label>
            <button className="button button-primary" type="submit">
              <Mail size={18} />
              {t("contact.form.submit")}
            </button>
            <p className="soft-note">{t("contact.form.note")}</p>
          </form>

          <aside className="contact-panel" data-reveal>
            <Mail size={28} />
            <h2>{t("contact.business.title")}</h2>
            <p>{t("contact.business.body")}</p>
            <a href={`mailto:${t(studioEmailKey)}`}>{t(studioEmailKey)}</a>
          </aside>
        </div>
      </section>
    </>
  );
}
